import { Link, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/feature/Breadcrumb";
import ScrollToTop from "@/components/feature/ScrollToTop";
import SEOHead from "@/components/feature/SEOHead";
import SchemaOrg from "@/components/feature/SchemaOrg";
import ComicCard from "@/components/feature/ComicCard";
import { comics, categories } from "@/mocks/comics";

export default function Home() {
  const navigate = useNavigate();
  const [activeCategory, setActiveCategory] = useState("all");
  const [showAllFeatured, setShowAllFeatured] = useState(false);

  const featuredComics = comics.filter((c) => [1, 2, 3, 4, 5, 8].includes(c.id));
  const latestComics = [...comics].sort(
    (a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime()
  );
  const popularComics = [...comics].sort((a, b) => b.views - a.views).slice(0, 6);
  const filteredComics =
    activeCategory === "all"
      ? comics
      : comics.filter((c) => c.category === activeCategory);

  const heroComic = comics[0];

  useEffect(() => {
    const root = document.getElementById("root");
    if (root) {
      root.style.overflowX = "hidden";
      return () => {
        root.style.overflowX = "";
      };
    }
  }, []);

  return (
    <>
      <SEOHead
        title="虚空韩漫网 - 韩漫画免费网站_漫画大全_韩漫完整在线观看"
        description="虚空韩漫网作为韩漫画免费网站，提供漫画大全和韩漫完整在线观看服务，涵盖恋爱、奇幻、动作、悬疑等多种类型韩漫，平台稳定是您可靠的长久阅读伙伴。"
        keywords="虚空韩漫网,韩漫画免费网站,漫画大全,韩漫完整在线观看,韩漫免费,韩漫阅读,韩国漫画"
        canonicalUrl="https://www.xukonghanman.com/"
        ogImage="https://readdy.ai/api/search-image?query=Korean%20webtoon%20website%20homepage%20banner%2C%20colorful%20manga%20style%20illustrations%20collage%2C%20warm%20inviting%20atmosphere%2C%20clean%20modern%20design%20elements%2C%20watercolor%20manga%20aesthetic&width=1200&height=630&seq=og-homepage&orientation=landscape"
      />
      <SchemaOrg
        type="Organization"
        data={{
          name: "虚空韩漫网",
          url: "https://www.xukonghanman.com/",
          description:
            "虚空韩漫网作为韩漫画免费网站，提供漫画大全和韩漫完整在线观看服务",
        }}
      />
      <SchemaOrg
        type="WebSite"
        data={{
          name: "虚空韩漫网",
          url: "https://www.xukonghanman.com/",
          potentialAction: {
            "@type": "SearchAction",
            target: "https://www.xukonghanman.com/search?q={search_term_string}",
            "query-input": "required name=search_term_string",
          },
        }}
      />
      <ScrollToTop />
      <Navbar />

      <main>
        <section
          className="relative w-full min-h-[550px] md:min-h-[650px] flex items-center overflow-hidden"
          aria-label="Hero推荐区域"
        >
          <img
            src="https://readdy.ai/api/search-image?query=Beautiful%20Korean%20webtoon%20style%20art%20collage%20with%20soft%20watercolor%20illustrations%20of%20romantic%20couple%2C%20fantasy%20castle%2C%20dramatic%20landscape%2C%20vibrant%20colors%2C%20dreamy%20atmosphere%2C%20clean%20composition%2C%20no%20text&width=1600&height=800&seq=hero-bg-home&orientation=landscape"
            alt="虚空韩漫网 Hero 背景"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>

          <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-20 md:py-28">
            <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
              <div className="flex-1 text-center lg:text-left">
                <h1 className="text-3xl md:text-5xl font-bold text-background-50 mb-4 leading-tight" style={{ fontFamily: "var(--font-heading)" }}>
                  虚空韩漫网
                </h1>
                <p className="text-lg md:text-xl text-background-50/90 mb-2">
                  韩漫画免费网站 · 漫画大全
                </p>
                <p className="text-sm md:text-base text-background-50/70 mb-8 max-w-lg">
                  提供海量韩漫完整在线观看服务，平台稳定、更新及时，是您可靠的长久阅读伙伴。每日更新，精彩不容错过。
                </p>
                <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
                  <Link
                    to={`/comic/${heroComic.slug}`}
                    className="px-8 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
                  >
                    立即阅读热门漫画
                  </Link>
                  <Link
                    to="/category/all"
                    className="px-8 py-3 bg-background-50/20 text-background-50 border border-background-50/30 rounded-full text-sm font-semibold hover:bg-background-50/30 transition-all duration-300 whitespace-nowrap cursor-pointer"
                  >
                    浏览漫画大全
                  </Link>
                </div>
                <div className="flex items-center gap-6 mt-8 justify-center lg:justify-start">
                  <div className="text-center">
                    <p className="text-2xl md:text-3xl font-bold text-background-50">{comics.length}+</p>
                    <p className="text-xs text-background-50/60">精品漫画</p>
                  </div>
                  <div className="w-px h-8 bg-background-50/20"></div>
                  <div className="text-center">
                    <p className="text-2xl md:text-3xl font-bold text-background-50">100+</p>
                    <p className="text-xs text-background-50/60">每日更新话数</p>
                  </div>
                  <div className="w-px h-8 bg-background-50/20"></div>
                  <div className="text-center">
                    <p className="text-2xl md:text-3xl font-bold text-background-50">50万+</p>
                    <p className="text-xs text-background-50/60">忠实读者</p>
                  </div>
                </div>
              </div>

              <div className="flex-shrink-0">
                <div className="relative w-64 md:w-72 lg:w-80">
                  <div className="absolute -inset-4 bg-primary-500/20 rounded-2xl blur-2xl"></div>
                  <img
                    src={heroComic.cover}
                    alt={heroComic.title}
                    className="relative rounded-xl shadow-lg w-full object-cover object-top aspect-[3/4]"
                    title={`${heroComic.title} - 虚空韩漫网热门推荐`}
                  />
                  <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 bg-background-50 rounded-full px-5 py-2 shadow-md flex items-center gap-2 whitespace-nowrap">
                    <span className="w-4 h-4 flex items-center justify-center text-accent-500">
                      <i className="ri-fire-fill"></i>
                    </span>
                    <span className="text-xs font-semibold text-foreground-900">本周热门 TOP 1</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-10 md:py-14 bg-background-50" aria-label="分类导航">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-lg md:text-xl font-bold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>
                漫画分类
              </h2>
            </div>
            <div className="flex items-center gap-2 flex-wrap">
              {categories.map((cat) => (
                <button
                  key={cat.slug}
                  onClick={() => {
                    setActiveCategory(cat.slug);
                    if (cat.slug !== "all") {
                      navigate(`/category/${cat.slug}`);
                    }
                  }}
                  className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                    activeCategory === cat.slug
                      ? "bg-primary-500 text-background-50"
                      : "bg-background-100 text-foreground-600 hover:bg-primary-100 hover:text-primary-500"
                  }`}
                >
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className={cat.icon}></i>
                  </span>
                  {cat.name}
                </button>
              ))}
            </div>
          </div>
        </section>

        {activeCategory !== "all" && (
          <section className="py-10 md:py-14 bg-background-50" aria-label={`${categories.find((c) => c.slug === activeCategory)?.name || ""}漫画列表`}>
            <div className="max-w-7xl mx-auto px-4 md:px-6">
              <h2 className="text-lg md:text-xl font-bold text-foreground-950 mb-6" style={{ fontFamily: "var(--font-heading)" }}>
                {categories.find((c) => c.slug === activeCategory)?.name}漫画
              </h2>
              {filteredComics.length > 0 ? (
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5">
                  {filteredComics.map((comic) => (
                    <ComicCard key={comic.id} {...comic} />
                  ))}
                </div>
              ) : (
                <div className="text-center py-16">
                  <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center text-foreground-300">
                    <i className="ri-emotion-sad-line text-4xl"></i>
                  </div>
                  <p className="text-foreground-500">该分类暂无漫画，敬请期待</p>
                </div>
              )}
            </div>
          </section>
        )}

        <section className="py-10 md:py-14 bg-background-100" aria-label="最新更新">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-lg md:text-xl font-bold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>
                最新更新
              </h2>
              <Link
                to="/category/all"
                className="text-sm text-primary-500 hover:text-primary-600 flex items-center gap-1 whitespace-nowrap transition-colors"
              >
                查看全部
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </Link>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5">
              {latestComics.slice(0, 12).map((comic) => (
                <ComicCard key={comic.id} {...comic} />
              ))}
            </div>
          </div>
        </section>

        <section className="py-10 md:py-14 bg-background-50" aria-label="热门漫画">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-lg md:text-xl font-bold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>
                热门漫画
              </h2>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5">
              {popularComics.map((comic, index) => (
                <div key={comic.id} className="relative">
                  {index < 3 && (
                    <div className="absolute -top-2 -left-2 z-10 w-7 h-7 rounded-full bg-accent-500 flex items-center justify-center">
                      <span className="text-[11px] font-bold text-background-50">{index + 1}</span>
                    </div>
                  )}
                  <ComicCard {...comic} />
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-10 md:py-14 bg-background-100" aria-label="精选推荐">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-lg md:text-xl font-bold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>
                精选推荐
              </h2>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
              {(showAllFeatured ? featuredComics : featuredComics.slice(0, 3)).map((comic) => (
                <Link
                  key={comic.id}
                  to={`/comic/${comic.slug}`}
                  className="group flex gap-4 p-4 rounded-xl bg-background-50 border border-background-200 hover:border-primary-200 transition-all duration-300 cursor-pointer"
                  data-product-shop
                >
                  <div className="w-20 md:w-24 flex-shrink-0 overflow-hidden rounded-lg">
                    <img
                      src={comic.cover}
                      alt={comic.title}
                      className="w-full aspect-[3/4] object-cover object-top rounded-lg transition-transform duration-500 group-hover:scale-105"
                      title={`${comic.title} - 虚空韩漫网精选推荐`}
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors truncate">
                      {comic.title}
                    </h3>
                    <p className="text-xs text-foreground-500 mt-1">{comic.author}</p>
                    <p className="text-xs text-foreground-600 mt-2 line-clamp-2 leading-relaxed">
                      {comic.description}
                    </p>
                    <div className="flex items-center gap-3 mt-3">
                      <span className="flex items-center gap-1 text-xs text-foreground-500">
                        <span className="w-3 h-3 flex items-center justify-center text-accent-500">
                          <i className="ri-star-fill text-[10px]"></i>
                        </span>
                        {comic.rating}
                      </span>
                      <span className={`text-[10px] px-2 py-0.5 rounded-full whitespace-nowrap ${
                        comic.status === "连载中"
                          ? "bg-accent-100 text-accent-700"
                          : "bg-foreground-200 text-foreground-600"
                      }`}>
                        {comic.status}
                      </span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
            {featuredComics.length > 3 && (
              <div className="text-center mt-6">
                <button
                  onClick={() => setShowAllFeatured(!showAllFeatured)}
                  className="px-6 py-2.5 rounded-full border border-primary-300 text-primary-500 text-sm font-medium hover:bg-primary-50 transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  {showAllFeatured ? "收起" : "查看更多精选"}
                  <span className={`w-4 h-4 inline-flex items-center justify-center ml-1 transition-transform duration-300 ${showAllFeatured ? "rotate-180" : ""}`}>
                    <i className="ri-arrow-down-s-line"></i>
                  </span>
                </button>
              </div>
            )}
          </div>
        </section>

        <section className="py-10 md:py-14 bg-background-50" aria-label="网站特色">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <h2 className="text-lg md:text-xl font-bold text-foreground-950 text-center mb-10" style={{ fontFamily: "var(--font-heading)" }}>
              为什么选择虚空韩漫网？
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {[
                {
                  icon: "ri-shield-check-line",
                  title: "平台稳定",
                  desc: "高性能服务器保障流畅阅读体验，7x24小时不间断服务，做您可靠的韩漫阅读平台",
                },
                {
                  icon: "ri-book-2-line",
                  title: "海量资源",
                  desc: "收录上万部精品韩漫，涵盖恋爱、奇幻、动作、悬疑等多种类型，满足不同阅读偏好",
                },
                {
                  icon: "ri-flashlight-line",
                  title: "更新及时",
                  desc: "与韩网同步更新，第一时间带来最新话数，让您不错过任何精彩内容",
                },
                {
                  icon: "ri-smartphone-line",
                  title: "多端阅读",
                  desc: "支持电脑、平板、手机等多种设备访问，随时随地享受韩漫阅读的乐趣",
                },
              ].map((item) => (
                <div
                  key={item.title}
                  className="text-center p-6 rounded-xl bg-background-100 border border-background-200"
                >
                  <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-primary-100 flex items-center justify-center">
                    <span className="w-6 h-6 flex items-center justify-center text-primary-500">
                      <i className={`${item.icon} text-xl`}></i>
                    </span>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-2">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-600 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}